<div class="search-loading" *ngIf="loadingSearch">
    <img src="assets/images/loader.gif">
</div>

<div *ngIf="!loadingSearch">
    <ng-container *ngIf="searchList.length >0 else noData">
        <ul *ngFor="let item of searchList">
            <li [routerLink]="['/pages/support-category-page/article/'+ item.id+'/'+item.title.split(' ').join('-')]">
                {{item.title}}</li>
        </ul>
    </ng-container>
    <ng-template #noData>
        <p class="p-2 m-0 text-center">{{'no data'|translate}}</p>
    </ng-template>

</div>

